import React, { lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import Layout from 'layouts'

const routes = [
  {
    path: '/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },

  
  {
    path: '/manage/user',
    Component: lazy(() => import('pages/manage/Users')),
    exact: true,
  },

  {
    path: '/manage/roles',
    Component: lazy(() => import('pages/manage/Roles')),
    exact: true,
  },
  {
    path: '/manage/organisation',
    Component: lazy(() => import('pages/manage/Organisation')),
    exact: true,
  },
  {
    path: '/manage/dashboard',
    Component: lazy(() => import('pages/manage/Dashboard')),
    exact: true,
  },
  {
    path: '/manage/bulk-sms',
    Component: lazy(() => import('pages/manage/BulkSms')),
    exact: true,
  },
]

const mapStateToProps = ({ settings }) => ({
  routerAnimation: settings.routerAnimation,
})

const Router = ({ history, routerAnimation }) => {
  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                >
                  <Switch location={location}>
                    <Route exact path="/" render={() => <Redirect to="/manage/user" />} />
                    {routes.map(({ path, Component, exact }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={() => {
                          return (
                            <div className={routerAnimation}>
                              <Suspense fallback={null}>
                                <Component />
                              </Suspense>
                            </div>
                          )
                        }}
                      />
                    ))}
                    <Redirect to="/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
